var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicTeam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3717",
    "data-name": "Group 3717",
    transform: "translate(-641 -340)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_323",
    "data-name": "Ellipse 323",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(641 340)",
    fill: "#fcf4f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3714",
    "data-name": "Group 3714",
    transform: "translate(657 292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17202",
    "data-name": "Path 17202",
    d: "M206.541,86.112a5.548,5.548,0,0,0,5.541-5.541v-4.03a5.541,5.541,0,1,0-11.082,0v4.03A5.548,5.548,0,0,0,206.541,86.112Z",
    transform: "translate(-180.749)",
    fill: "#f6ad93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17203",
    "data-name": "Path 17203",
    d: "M147.4,226.071a8.55,8.55,0,0,1-12.106,0A12.857,12.857,0,0,0,128.5,237.4v8.816a1.511,1.511,0,0,0,1.511,1.511H152.68a1.511,1.511,0,0,0,1.511-1.511V237.4A12.857,12.857,0,0,0,147.4,226.071Zm-3.031,11.881h-1.511v1.511a1.511,1.511,0,0,1-3.023,0v-1.511h-1.511a1.511,1.511,0,0,1,0-3.023h1.511v-1.511a1.511,1.511,0,0,1,3.023,0v1.511h1.511a1.511,1.511,0,0,1,0,3.023Z",
    transform: "translate(-115.554 -139.448)",
    fill: "#f16238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17204",
    "data-name": "Path 17204",
    d: "M366.534,124.888a4.539,4.539,0,0,0,4.534-4.534v-2.821a4.534,4.534,0,0,0-9.067,0v2.821A4.539,4.539,0,0,0,366.534,124.888Z",
    transform: "translate(-325.529 -37.769)",
    fill: "#f6ad93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17205",
    "data-name": "Path 17205",
    d: "M64.534,124.888a4.539,4.539,0,0,0,4.534-4.534v-2.821a4.534,4.534,0,1,0-9.067,0v2.821A4.539,4.539,0,0,0,64.534,124.888Z",
    transform: "translate(-53.955 -37.769)",
    fill: "#f6ad93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17206",
    "data-name": "Path 17206",
    d: "M399.285,236.716a7.532,7.532,0,0,1-7.048,2.3,15.831,15.831,0,0,1,2.142,7.957v6.8h8.413a1.511,1.511,0,0,0,1.511-1.511v-6.549A10.581,10.581,0,0,0,399.285,236.716Z",
    transform: "translate(-352.719 -149.02)",
    fill: "#f16238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17207",
    "data-name": "Path 17207",
    d: "M5.018,236.716a10.581,10.581,0,0,0-5.018,9v6.549a1.511,1.511,0,0,0,1.511,1.511H9.924v-6.8a15.831,15.831,0,0,1,2.142-7.957,7.532,7.532,0,0,1-7.048-2.3Z",
    transform: "translate(0 -149.02)",
    fill: "#f16238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicTeam);
export default __webpack_public_path__ + "static/media/Clinic Team.567e033944f6f572b4454f32d96d8fa1.svg";
export { ForwardRef as ReactComponent };